import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Routes, Route } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";

import "./index.css";

import Chat from "./pages/chat/Chat";
import Layout from './pages/layout/Layout';
import LoginFailed from "./pages/LoginFailed";
import NoPage from "./pages/NoPage";
import { AppStateProvider } from "./state/AppProvider";
import { FeedbackProvider } from "./components/Feedback/FeedbackProvider";
import { TextProvider } from "./context/TextProvider";
import { withCookieCheck } from './withCookieCheck';

initializeIcons();

const ProtectedLayout = withCookieCheck(Layout);

export default function App() {
    return (
        <TextProvider>
            <FeedbackProvider>
                <AppStateProvider>
                    <HashRouter>
                        <Routes>
                            <Route path="/" element={<ProtectedLayout />}>
                                <Route index element={<Chat />} />
                                <Route path="chat/*" element={<Chat />} />
                                <Route path="login_failed" element={<LoginFailed />} />
                                <Route path="*" element={<NoPage />} />
                            </Route>
                        </Routes>
                    </HashRouter>
                </AppStateProvider>
            </FeedbackProvider>
        </TextProvider>
    );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
